import { AxiosRequestConfig } from 'axios';

import { fetcher } from '@hh.ru/front-static-app';

import { AreaId } from 'src/types/area';
import { CalculatorTabloRes } from 'src/types/calculator';
import { GradeId } from 'src/types/grade';

export const POST_CALCULATOR_CALCULATE_HOST = '/shards/calculator/calculate';

interface BodyValues {
    professionId: string;
    skillIds: number[];
    gradeId?: GradeId;
    areaId: AreaId;
}

type Response = CalculatorTabloRes;

declare global {
    interface FetcherPostApi {
        [POST_CALCULATOR_CALCULATE_HOST]: { body: BodyValues; queryParams: void; response: Response };
    }
}

const postCalculate = async (values: BodyValues, reqConfig: AxiosRequestConfig = {}): Promise<Response> => {
    const { data } = await fetcher.post(POST_CALCULATOR_CALCULATE_HOST, values, {
        params: undefined,
        ...reqConfig,
    });
    return data;
};

export default postCalculate;
